import React from "react";
import { Link,useNavigate } from "react-router-dom";
import "./SuccessfullHomework.css";

const SuccessfullHomework = () => {
  const navigate = useNavigate();
  let Header=localStorage.getItem("Header");
  const OkayClickHandle=()=>{
    navigate(Header==="Content Management (Homework)"?"/contentMangment":"/PublishedHomework")
    if(Header==="Content Management (Homework)"){
      localStorage.setItem("Header","Content Management");
    }
  }
  return (
    <div className=" successful_preview_transprant_body ">
      <div className=" p-2 successful_preview_container shadow">
        <img className="prereadLoader" src="/gift/tick_mark.gif" alt="" />
        <span className=" my-4 successfully_message">
          You have successfully published Homework.
        </span>
        <button className="successfull_okay_btn" onClick={()=>{OkayClickHandle()}}>Okay</button>
      </div>
    </div>
  );
};

export default SuccessfullHomework;
